const data = {
  wish: {
    id: 'title',
    label: 'Title',
    name: 'title',
    placeholder: 'For the future, I wish ...'
  },
  location: {
    id: 'userResidence',
    label: 'Your city',
    name: 'userResidence',
    placeholder: 'Type in your city',
    labels: {
      giveConsentCopy: 'Consent Copy',
      giveConsentDetailsCta: 'Consent Details CTA',
      giveConsentCta: 'Consent CTA'
    }
  },
  age: {
    label: 'Your age',
    cells: [
      {
        id: '0-20',
        name: 'userAgeGroup',
        label: '0-20',
        value: '0-20'
      },
      {
        id: '21-40',
        name: 'userAgeGroup',
        label: '21-40',
        value: '21-40'
      },
      {
        id: '41-60',
        name: 'userAgeGroup',
        label: '41-60',
        value: '41-60'
      },
      {
        id: '60+',
        name: 'userAgeGroup',
        label: '60+',
        value: '60+'
      }
    ]
  },
  gender: {
    label: 'Your gender',
    cells: [
      {
        id: 'm',
        name: 'userGender',
        label: 'Male',
        value: 'm'
      },
      {
        id: 'f',
        name: 'userGender',
        label: 'Female',
        value: 'f'
      },
      {
        id: 'd',
        name: 'userGender',
        label: 'Non-Binary',
        value: 'd'
      }
    ]
  },
  actions: {
    prev: 'Back',
    next: 'Next',
    submit: 'Submit your wish'
  }
};

export default data;
